'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMentions = exports.toEditorState = exports.toString = exports.Nav = undefined;

var _rcEditorCore = require('rc-editor-core');

var _Mention = require('./component/Mention.react');

var _Mention2 = _interopRequireDefault(_Mention);

var _exportContent = require('./utils/exportContent');

var _exportContent2 = _interopRequireDefault(_exportContent);

var _getMentions = require('./utils/getMentions');

var _getMentions2 = _interopRequireDefault(_getMentions);

var _Nav = require('./component/Nav.react');

var _Nav2 = _interopRequireDefault(_Nav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Mention2["default"].Nav = _Nav2["default"]; // export this package's api

_Mention2["default"].toString = _exportContent2["default"];
_Mention2["default"].toEditorState = _rcEditorCore.toEditorState;
_Mention2["default"].getMentions = _getMentions2["default"];

exports.Nav = _Nav2["default"];
exports.toString = _exportContent2["default"];
exports.toEditorState = _rcEditorCore.toEditorState;
exports.getMentions = _getMentions2["default"];
exports["default"] = _Mention2["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-editor-mention/lib/index.js
 ** module id = 571
 ** module chunks = 0 1
 **/